import React, { useState } from 'react';
import StarRatings from 'react-star-ratings';

import { RatingDiv } from './style';

const Rating = () => {
    const [rate, setRate] = useState(0);

    const handleChangeRating = (stars) => {
        setRate(stars)
    }
    return (
        <RatingDiv>
            <StarRatings
                rating={rate}
                starRatedColor="#ff6f69"
                starHoverColor="#ff6f69"
                changeRating={handleChangeRating}
                numberOfStars={5}
                name='rating'
                starDimension="20px"
                starSpacing="5px"
            />
        </RatingDiv>
    );
} 

export default Rating;